import { css } from 'lit';
export const timeredCounterNumberStyles = css ``;
//# sourceMappingURL=timered-counter-number-styles.js.map